/* global axios */

// Solicitações de transferência de ATENDIMENTO (assignee da conversa).
// Espelha conversationTransferRequests.js, que faz o mesmo para carteirização.
// São fluxos distintos por regra de negócio: transferir o atendimento não
// altera a propriedade do lead.

const accountId = () => {
  if (window.location.pathname.includes('/app/accounts')) {
    return window.location.pathname.split('/')[3];
  }
  return '';
};

const baseUrl = () =>
  `/api/v1/accounts/${accountId()}/aceleres/assignment_transfer_requests`;

let requestSequence = 0;
const freshParams = (params = {}) => {
  requestSequence += 1;
  return {
    params: {
      ...params,
      cache_bust: `${Date.now()}-${requestSequence}`,
    },
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    },
  };
};

export default {
  pending() {
    return axios.get(baseUrl(), freshParams());
  },
  mine() {
    return axios.get(baseUrl(), freshParams({ scope: 'mine' }));
  },
  team() {
    return axios.get(baseUrl(), freshParams({ scope: 'team' }));
  },
  status(conversationId) {
    return axios.get(
      `${baseUrl()}/status`,
      freshParams({ conversation_id: conversationId })
    );
  },
  create({ conversationId, targetAssigneeId, justification }) {
    return axios.post(baseUrl(), {
      conversation_id: conversationId,
      target_assignee_id: targetAssigneeId,
      justification,
    });
  },
  approve(id) {
    return axios.post(`${baseUrl()}/${id}/approve`);
  },
  reject(id, reason = null) {
    return axios.post(`${baseUrl()}/${id}/reject`, { reason });
  },
};
